import { ReactNode } from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { useTranslation } from "react-i18next";
import styles from "@/components/forms/inputs/dropDownOptionPreloadRow.module.css";

interface Props {
  disabled?: boolean;
  hasLoadedOptions?: boolean;
  isLoading?: boolean;
  onBlur?: () => void;
  onPreload?: () => void;
  children: ReactNode;
}

export default function DropDownOptionPreloadRow({
  disabled,
  hasLoadedOptions,
  isLoading,
  onBlur,
  onPreload,
  children,
}: Props) {
  const { t } = useTranslation();

  if (!onPreload) {
    return children;
  }

  const label = hasLoadedOptions
    ? t("all_options_loaded")
    : t("load_all_options");

  return (
    <div
      className={styles.controlRow}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
          onBlur?.();
        }
      }}
    >
      <div className={styles.select}>{children}</div>
      <Tooltip title={label}>
        <span className={styles.buttonWrap}>
          <IconButton
            type="button"
            aria-label={label}
            disabled={disabled || isLoading}
            onClick={onPreload}
            className={
              hasLoadedOptions
                ? `${styles.button} ${styles.loaded}`
                : styles.button
            }
          >
            {isLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <FormatListBulletedIcon fontSize="small" />
            )}
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
}
